import { MutedNavLink } from '@/components/MutedNavLink';
import type { ReactNode } from 'react';

interface BackLinkProps {
  to: string;
  children: ReactNode;
}

/**
 * BackLink — the "← back" navigation chrome for returning to the previous
 * context. A thin specialisation of `MutedNavLink` (muted, never pink, 44px
 * touch target); see that component for the shared treatment.
 *
 * Use across all flat pages (ServiceLog, ProjectsPage, ServiceEntryDetail,
 * Diagnose, TransferInitiate, TransferAccept, VehicleGenesisPage).
 *
 * Exception: VehicleDetail's back-link sits above the ruled dossier spec-block
 * and also uses BackLink, but the dossier title stays inside that block
 * (not in a PageHeader).
 */
export function BackLink({ to, children }: BackLinkProps) {
  return <MutedNavLink to={to}>{children}</MutedNavLink>;
}
